export default __webpack_public_path__ + "static/media/Inter-Light.51f4d175.woff2";